import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,
} from "../Services/Urls";

import { callApi, makeApiRequest } from "../Services/ApiService";
import { decryptOtp } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { getRecords, PostRecords } from "../Services/ApiCall";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import Footer from "../Common/Footer";
import Header from "../Common/Header";

import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";

import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";

import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import { getUserLocation } from "../Services/Helper";

function SidebarFilter({ filters, onChange }) {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,
    setCityData,
    vertical,
    setVertical,
    properType,
    setproperType,
    coordinates,
    setcoordinates,
    BHKData,
    setBHKData,
    Locality,
    setLocality,
    Area,
    setArea,
    Projects,
    setProjects,
    searchData,
    setsearchData,

    FurnishType,
    setFurnishType,
    societyAmenities,
    setSocietyAmenities,
    constructionStatus,
    setConstructionStatus,
    propertyAmenities,
    setPropertyAmenities,
    roomConfig,
    setRoomConfig,
    Meals,
    setMeals,
    CommonArea,
    setCommonArea,
    PGisFor,
    setPGisFor,
    bestSuitFor,
    setBestSuitFor,
    selected_FurnishType,
    setSelectedFurnishType,
    selected_societyAmenities,
    setSelectedSocietyAmenities,
    selected_constructionStatus,
    setSelectedConstructionStatus,
    selected_propertyAmenities,
    setSelectedPropertyAmenities,
    selected_roomConfig,
    setSelectedRoomConfig,
    selected_Meals,
    setSelectedMeals,
    selected_CommonArea,
    setSelectedCommonArea,
    selected_PGisFor,
    setSelectedPGisFor,
    selected_bestSuitFor,
    setSelectedBestSuitFor,
    selected_vertical,
    setSelectedVertical,
    selected_properType,
    setSelectedProperType,
    selected_BHKData,
    setSelectedBHKData,
  } = useContext(ApiContext);

  const [ChooseProperty, setChooseProperty] = useState([]);
  const [Selected_ChooseProperty, setSelectedChooseProperty] = useState([]);

  useEffect(() => {
    if (vertical.length === 0) {
      getVerticalType();
    }

    if (properType.length === 0) {
      getPropertyType();
    }

    if (BHKData.length === 0) {
      getBHKType();
    }

    if (FurnishType.length === 0) {
      getFurnishType();
    }

    if (societyAmenities.length === 0) {
      getSocietyAmenities();
    }

    if (constructionStatus.length === 0) {
      getConstructionStatus();
    }

    if (propertyAmenities?.length === 0) {
      getpropertyAmenities();
    }

    if (filters?.vertical === 3) {
      if (roomConfig?.length === 0) {
        getRoomConfig();
      }

      if (Meals?.length === 0) {
        getMeals();
      }

      if (CommonArea?.length === 0) {
        getCommonArea();
      }
    }

    if (ChooseProperty?.length === 0) {
      getChoosePropertyType();
    }
  }, []);

  const getChoosePropertyType = () => {
    getRecords(
      411,
      100,
      `{PropertyTypeID: { $in: [${filters?.propertyType}] },VerticalID: { $in: [${filters?.vertical}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setChooseProperty(data?.response?.records || []);
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      }
    );
  };

  const getPropertyType = () => {
    getRecords(391, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setproperType(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getVerticalType = () => {
    getRecords(392, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setVertical(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getBHKType = () => {
    getRecords(394, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setBHKData(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getFurnishType = () => {
    getRecords(395, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setFurnishType(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getSocietyAmenities = () => {
    getRecords(396, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setSocietyAmenities(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getConstructionStatus = () => {
    getRecords(406, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setConstructionStatus(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getpropertyAmenities = () => {
    getRecords(397, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyAmenities(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getRoomConfig = () => {
    getRecords(421, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setRoomConfig(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getMeals = () => {
    getRecords(422, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setMeals(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getCommonArea = () => {
    getRecords(423, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setCommonArea(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  //console.log("Selected Filters in SidebarFilter:", filters);

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-widget style4">
          <div className="d-flexx">
            <h6>Filters</h6>
            <a href="#">Clear All</a>
          </div>
          {/* <div className="fblock">
            <strong>Property Type</strong>
            {properType?.map((type, index) => (
              <div className="d-block" key={index}>
                <input
                  type="radio"
                  id={`choice${index}`}
                  name="choice"
                  value={type?.value}
                />
                <label htmlFor={`choice${index}`}>{type?.PropertyType}</label>
              </div>
            ))}
          </div>

          <div className="fblock">
            <strong>Looking For</strong>
            {vertical?.map((type, index) => (
              <div key={index} className="d-block">
                <input type="radio" id="buy" name="choice2" value="Buy" />
                <label htmlFor="buy">{type?.Vertical}</label>
              </div>
            ))}
          </div> */}

          <div className="fblock">
            <strong>Property Type</strong>
            {ChooseProperty?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.ChoosePropertyID}
                  checked={Selected_ChooseProperty.some(
                    (v) => v.ChoosePropertyID === type.ChoosePropertyID
                  )}
                  onChange={() => {
                    setSelectedChooseProperty((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.ChoosePropertyID === type.ChoosePropertyID
                      )
                        ? prev.filter(
                            (v) => v.ChoosePropertyID !== type.ChoosePropertyID
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        propertyTypeIds: nextSelected.map(
                          (item) => item.ChoosePropertyID
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.ChooseProperty}>{type?.ChooseProperty}</label>
              </div>
            ))}
          </div>

          {filters?.propertyType === 1 &&
            (filters?.vertical === 1 || filters?.vertical === 2) && (
              <div className="fblock">
                <strong>No. of Rooms</strong>
                {BHKData?.map((type, index) => (
                  <div key={index} className="d-block">
                    <input
                      type="checkbox"
                      id={type.BHKID}
                      checked={selected_BHKData.some(
                        (v) => v.BHKID === type.BHKID
                      )}
                      onChange={() => {
                        setSelectedBHKData((prev) => {
                          const nextSelected = prev.some(
                            (v) => v.BHKID === type.BHKID
                          )
                            ? prev.filter((v) => v.BHKID !== type.BHKID) // remove
                            : [...prev, type]; // add object

                          // 🔑 update filters using the SAME derived data
                          onChange((filtersPrev) => ({
                            ...filtersPrev,
                            bhkTypeIds: nextSelected.map((item) => item.BHKID),
                          }));

                          return nextSelected;
                        });
                      }}
                    />
                    <label htmlFor={type?.BHKUnit}>{type?.BHKUnit}</label>
                  </div>
                ))}
              </div>

              /* your additional condition here */
            )}

          <div className="fblock">
            <strong>Construction Status</strong>
            {constructionStatus?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.ConstructionStatusID}
                  checked={selected_constructionStatus.some(
                    (v) => v.ConstructionStatusID === type.ConstructionStatusID
                  )}
                  onChange={() => {
                    setSelectedConstructionStatus((prev) => {
                      const nextSelected = prev.some(
                        (v) =>
                          v.ConstructionStatusID === type.ConstructionStatusID
                      )
                        ? prev.filter(
                            (v) =>
                              v.ConstructionStatusID !==
                              type.ConstructionStatusID
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        constructionStatusIds: nextSelected.map(
                          (item) => item.ConstructionStatusID
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.ConstructionStatus}>
                  {type?.ConstructionStatus}
                </label>
              </div>
            ))}
          </div>

          <div className="fblock">
            <strong>Furnish Type</strong>
            {FurnishType?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.FurnishID}
                  checked={selected_FurnishType.some(
                    (v) => v.FurnishID === type.FurnishID
                  )}
                  onChange={() => {
                    setSelectedFurnishType((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.FurnishID === type.FurnishID
                      )
                        ? prev.filter((v) => v.FurnishID !== type.FurnishID) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        furnishingTypeIds: nextSelected.map(
                          (item) => item.FurnishID
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.FurnishType}>{type?.FurnishType}</label>
              </div>
            ))}
          </div>

          {filters?.propertyType === 1 && filters?.vertical === 3 && (
            <>
              <div className="fblock">
                <strong>PG Is For</strong>
                {PGisFor?.map((type, index) => (
                  <div key={index} className="d-block">
                    <input
                      type="checkbox"
                      id={type.name}
                      checked={selected_PGisFor.some((v) => v.id === type.id)}
                      onChange={() => {
                        setSelectedPGisFor((prev) => {
                          const nextSelected = prev.some(
                            (v) => v.id === type.id
                          )
                            ? prev.filter((v) => v.id !== type.id) // remove
                            : [...prev, type]; // add object

                          // 🔑 update filters using the SAME derived data
                          onChange((filtersPrev) => ({
                            ...filtersPrev,
                            PGisFor: nextSelected.map((item) => item.id),
                          }));

                          return nextSelected;
                        });
                      }}
                    />
                    <label htmlFor={type?.name}>{type?.name}</label>
                  </div>
                ))}
              </div>

              <div className="fblock">
                <strong>Best Suited For</strong>
                {bestSuitFor?.map((type, index) => (
                  <div key={index} className="d-block">
                    <input
                      type="checkbox"
                      id={type.name}
                      checked={selected_bestSuitFor.some(
                        (v) => v.id === type.id
                      )}
                      onChange={() => {
                        setSelectedBestSuitFor((prev) => {
                          const nextSelected = prev.some(
                            (v) => v.id === type.id
                          )
                            ? prev.filter((v) => v.id !== type.id) // remove
                            : [...prev, type]; // add object

                          // 🔑 update filters using the SAME derived data
                          onChange((filtersPrev) => ({
                            ...filtersPrev,
                            BestSuitedFor: nextSelected.map((item) => item.id),
                          }));

                          return nextSelected;
                        });
                      }}
                    />
                    <label htmlFor={type?.name}>{type?.name}</label>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="fblock">
            <strong>Budget</strong>
            <div className="d-block">
              <div className="form-group">
                <input type="text" placeholder="Min" />
              </div>
            </div>
            <div className="d-block">
              <div className="form-group">
                <input type="text" placeholder="Max" />
              </div>
            </div>
          </div>

          {filters?.propertyType === 1 &&
            (filters?.vertical === 1 || filters?.vertical === 2) && (
              <>
                <div className="fblock">
                  <strong>Society Amenities</strong>
                  {societyAmenities?.map((type, index) => (
                    <div key={index} className="d-block">
                      <input
                        type="checkbox"
                        id={type.PropertyAmenitiesID}
                        checked={selected_societyAmenities.some(
                          (v) =>
                            v.PropertyAmenitiesID === type.PropertyAmenitiesID
                        )}
                        onChange={() => {
                          setSelectedSocietyAmenities((prev) => {
                            const nextSelected = prev.some(
                              (v) =>
                                v.PropertyAmenitiesID ===
                                type.PropertyAmenitiesID
                            )
                              ? prev.filter(
                                  (v) =>
                                    v.PropertyAmenitiesID !==
                                    type.PropertyAmenitiesID
                                ) // remove
                              : [...prev, type]; // add object

                            // 🔑 update filters using the SAME derived data
                            onChange((filtersPrev) => ({
                              ...filtersPrev,
                              societyAmenities: nextSelected.map(
                                (item) => item.PropertyAmenitiesID
                              ),
                            }));

                            return nextSelected;
                          });
                        }}
                      />
                      <label htmlFor="Lift">{type?.PropertyAmenities}</label>
                    </div>
                  ))}
                </div>

                <div className="fblock">
                  <strong>Property Furnishings</strong>
                  {propertyAmenities?.map((type, index) => (
                    <div key={index} className="d-block">
                        <input
                        type="checkbox"
                        id={type.UnitFurnishingID}
                        checked={selected_propertyAmenities.some(
                          (v) =>
                            v.UnitFurnishingID === type.UnitFurnishingID
                        )}
                        onChange={() => {
                          setSelectedPropertyAmenities((prev) => {
                            const nextSelected = prev.some(
                              (v) =>
                                v.UnitFurnishingID ===
                                type.UnitFurnishingID
                            )
                              ? prev.filter(
                                  (v) =>
                                    v.UnitFurnishingID !==
                                    type.UnitFurnishingID
                                ) // remove
                              : [...prev, type]; // add object

                            // 🔑 update filters using the SAME derived data
                            onChange((filtersPrev) => ({
                              ...filtersPrev,
                              propertyAmenities: nextSelected.map(
                                (item) => item.UnitFurnishingID
                              ),
                            }));

                            return nextSelected;
                          });
                        }}
                      />
                      <label htmlFor="Lift">{type?.UnitFurnishing}</label>
                    </div>
                  ))}
                </div>
              </>
            )}

          {/* <div className="fblock">
            <strong>Posted By</strong>
            <div className="d-block">
              <input
                type="checkbox"
                id="Owner"
                name="Owner"
                value="Verified Owner"
              />
              <label htmlFor="Owner">Verified Owner</label>
            </div>
            <div className="d-block">
              <input
                type="checkbox"
                id="Agent"
                name="Agent"
                value="Verified Agent"
              />
              <label htmlFor="Agent">Verified Agent</label>
            </div>
            <div className="d-block">
              <input
                type="checkbox"
                id="Builder"
                name="Builder"
                value="Builder"
              />
              <label htmlFor="Builder">Builder</label>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default SidebarFilter;
